import { SignUp as ClerkSignUp } from "@clerk/clerk-react";
import urls from "../../routes";
import clerkTheme from "../../ui/ClerkTheme/ClerkTheme";
import image from "../../images/login-signup.webp";
import styles from "./SignUp.module.scss";
import { useEffect } from "react";

function SignUp() {
  useEffect(() => {
    document.title = `Sign Up | Macaw`;
  }, []);

  return (
    <div className={styles.container}>
      <div className={styles.formContainer}>
        <ClerkSignUp
          appearance={clerkTheme}
          routing="virtual"
          signInUrl={urls.signIn}
        />
      </div>
      <div className={styles.imageContainer}>
        <img alt="" className={styles.image} src={image} />
      </div>
    </div>
  );
}

export default SignUp;
